/**
 * Delivery Options — Strip + Modal
 * Truman Tools & Equipment
 *
 * Opens/closes the native <dialog> modal, traps focus while open,
 * and restores focus to the trigger on close. Works for any number
 * of instances on the page (theme editor may render more than one).
 */
(function () {
  function trapFocus(dialog) {
    var focusable = dialog.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    dialog.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });
  }

  function openModal(trigger) {
    var targetId = trigger.getAttribute('data-target');
    var dialog = document.getElementById(targetId);
    if (!dialog) return;

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }

    document.documentElement.style.overflow = 'hidden';
    trapFocus(dialog);

    var closeBtn = dialog.querySelector('[data-delivery-close]');
    if (closeBtn) closeBtn.focus();

    dialog.addEventListener(
      'close',
      function () {
        document.documentElement.style.overflow = '';
        trigger.focus();
      },
      { once: true }
    );
  }

  function closeModal(dialog) {
    if (typeof dialog.close === 'function') {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      document.documentElement.style.overflow = '';
    }
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-delivery-open]');
    if (opener) {
      e.preventDefault();
      openModal(opener);
      return;
    }

    var closer = e.target.closest('[data-delivery-close]');
    if (closer) {
      var dialog = closer.closest('dialog');
      if (dialog) closeModal(dialog);
      return;
    }

    // Click on the ::backdrop / outside the panel closes the dialog
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('truman-delivery-modal')) {
      closeModal(e.target);
    }
  });

  document.addEventListener('cancel', function (e) {
    // Native ESC handling for <dialog> already fires 'close'; this
    // just ensures the scroll lock is released on all browsers.
    if (e.target.classList && e.target.classList.contains('truman-delivery-modal')) {
      document.documentElement.style.overflow = '';
    }
  }, true);
})();
